interface SkillType {
    [key: number]: string;
}

export const CustomSkillsTypes:SkillType = []
CustomSkillsTypes[1] = "string"
CustomSkillsTypes[2] = "number"

